import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
export default function ScienceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-testid": "icon-science",
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_1044:40636)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.73,
    cy: 29.717,
    r: 7.266,
    fill: "#FB517E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.116 34.83a7.266 7.266 0 006.522-10.47 7.266 7.266 0 11-11.43 8.562 7.24 7.24 0 004.908 1.908z",
    fill: "#D62454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.993 29.717c0 7.53-1.543 14.3-3.991 19.148-2.477 4.906-5.716 7.569-9.002 7.569-3.287 0-6.525-2.663-9.002-7.57-2.448-4.848-3.991-11.616-3.991-19.147 0-7.531 1.543-14.3 3.991-19.148C23.475 5.663 26.713 3 30 3c3.286 0 6.525 2.663 9.002 7.569 2.448 4.849 3.99 11.617 3.99 19.148z",
    stroke: "#468CFB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.496 18.465c6.522 3.765 11.612 8.486 14.588 13.03 3.01 4.598 3.697 8.734 2.053 11.58-1.643 2.846-5.568 4.32-11.055 4.012-5.423-.305-12.057-2.353-18.579-6.118-6.521-3.766-11.611-8.486-14.587-13.03-3.01-4.598-3.697-8.735-2.053-11.58 1.643-2.847 5.568-4.32 11.055-4.012 5.423.304 12.056 2.352 18.578 6.118z",
    stroke: "#468CFB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.496 40.97c-6.522 3.765-13.155 5.812-18.578 6.117-5.487.308-9.412-1.166-11.056-4.012-1.643-2.846-.956-6.982 2.054-11.58 2.975-4.544 8.065-9.265 14.587-13.03 6.522-3.766 13.155-5.813 18.579-6.118 5.487-.308 9.412 1.165 11.055 4.011 1.643 2.846.957 6.983-2.053 11.58-2.976 4.545-8.066 9.266-14.588 13.031z",
    stroke: "#468CFB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.691,
    cy: 44.691,
    r: 2.691,
    fill: "#FFE0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 45a3 3 0 11-6 0 3 3 0 016 0z",
    fill: "#002661"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.691,
    cy: 5.691,
    r: 2.691,
    fill: "#FFE0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 6a3 3 0 11-6 0 3 3 0 016 0z",
    fill: "#002661"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.691,
    cy: 45.691,
    r: 2.691,
    fill: "#FFE0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 46a3 3 0 11-6 0 3 3 0 016 0z",
    fill: "#002661"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_1044:40636"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  }))));
}